import {
  deriveWorkflowStage,
  getDaysWaiting,
  getCampaignThumbnailUrl,
  deriveCollaborationHealth as deriveBrandCollaborationHealth,
  WORKFLOW_STAGES,
  HEALTH_LABELS,
} from './brandOperationsUtils';
import { isJourneyItemComplete } from './collaborationJourneyStats';
import {
  enrichOperationsItem,
  filterOperationsList,
  partitionOperationsItems,
  sortOperationsList,
} from './OperationsListUtils';

export { WORKFLOW_STAGES, HEALTH_LABELS };

function extractBrandAvatarFromSource(source) {
  if (!source) return null;
  const url = source.brand_logo_url
    || source.company_logo
    || source.logo_url
    || source.brand_profile_picture;
  if (url && !String(url).startsWith('blob:')) return url;
  return null;
}

export function getBrandAvatarUrl(...sources) {
  for (let i = 0; i < sources.length; i += 1) {
    const avatar = extractBrandAvatarFromSource(sources[i]);
    if (avatar) return avatar;
  }
  return null;
}

/** Same thresholds as brand; ownership means creator-owned when not waiting. */
export function deriveCollaborationHealth(item, daysWaiting) {
  return deriveBrandCollaborationHealth(item, daysWaiting);
}

export function enrichInfluencerOperationsItem(journeyItem, stepSource) {
  return enrichOperationsItem(journeyItem, stepSource, {
    deriveHealth: deriveCollaborationHealth,
    getDaysWaiting,
    deriveWorkflowStage,
    getCampaignThumbnailUrl,
    getPartyAvatar: (step, item) => getBrandAvatarUrl(step, item),
    partyAvatarKey: 'brand_avatar',
    payoutPerspective: 'influencer',
  });
}

export function buildInfluencerOperationsStats(items) {
  const active = items.filter((item) => !isJourneyItemComplete(item));
  return {
    needsAction: items.filter((item) => !item.journey_waiting && !isJourneyItemComplete(item)).length,
    waitingOnBrand: items.filter((item) => item.journey_waiting && !isJourneyItemComplete(item)).length,
    completed: items.filter((item) => isJourneyItemComplete(item)).length,
    atRisk: active.filter((item) => item.health === 'at_risk').length,
  };
}

export function partitionInfluencerOperationsItems(items) {
  return partitionOperationsItems(items);
}

export function filterInfluencerOperationsItems(items, options = {}) {
  return filterOperationsList(items, {
    ...options,
    partyFields: ['brand_name', 'company_name'],
  });
}

export function sortInfluencerOperationsItems(items, sortBy = 'urgency') {
  return sortOperationsList(items, sortBy, {
    partySortKey: 'brand',
    partyFields: ['brand_name', 'company_name'],
  });
}
